// extracted by mini-css-extract-plugin
export default {"title":"Title_title__IlEm8","subtitle":"Title_subtitle__vg71A"};